"use client"
import { useEffect, useState } from "react"
import { store } from "@utils/store"

/**
 * @param id {number}
 * @returns {boolean}
 */
export function useFavorite(id) {
    const [isFavorite, setIsFavorite] = useState(false)
    useEffect(() => {
        const f = store.get(store.k.favorites) || {}
        setIsFavorite(!!f[id])
        const unwatch = store.watch(store.k.favorites, (favorites) => {
            setIsFavorite(!!favorites[id])
        })
        return () => unwatch()
    }, [id])
    return isFavorite
}
